/**
 * Centralized contact details for Falashop.
 * Import these constants instead of hardcoding emails, phone numbers,
 * addresses, or social links anywhere in the app.
 */

/** Single professional inbox (Zoho-hosted, falashop.com domain) for all customer-facing contact. */
export const CONTACT_EMAIL = 'contact@falashop.com';
export const CONTACT_EMAIL_HREF = `mailto:${CONTACT_EMAIL}`;

export const PHONE_NUMBER = '+227 90 12 34 56';
export const PHONE_NUMBER_HREF = 'tel:+22790123456';

export const COMPANY_ADDRESS = "Quartier Plateau, Niamey, Niger";
export const COMPANY_ADDRESS_MAPS_URL = "https://maps.google.com/?q=Quartier+Plateau,+Niamey,+Niger";

export const BUSINESS_HOURS = 'Lundi - Vendredi: 9h00 - 18h00';

export const SOCIAL_LINKS = {
    facebook: '#',
    twitter: '#',
    instagram: '#',
    youtube: '#',
};
